export default __webpack_public_path__ + "static/Lebenslauf_2021-min-5c27bccfb8a3f40169ad6aa30175320d.pdf";